import React from 'reactn';
import { separadoComas } from "../../../util/functions"
import { UnidadBase } from './UnidadBase.atomo';

export const UnidadPorcentaje = (rowData, column) =>{
    return <span>{separadoComas(rowData[column.field])}<span className="label-unidad">%</span></span>
}
export const UnidadPorcentajeComponente = (props) => <UnidadBase {...props} unidad="%"/>